import { useMutation } from "@tanstack/react-query";
import { isAxiosError } from "axios";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { postAuthorizedJSON } from "../lib/fetch";

type SyncTptReceptionParams = {
  client: string;
};

type SyncTptReceptionPayload = {
  portfolio_date: string;
  action_button_name: string;
  action_execution_page: string;
};

export const useSyncTptReception = ({ client }: SyncTptReceptionParams) => {
  const { t } = useTranslation();

  return useMutation({
    mutationFn: async (payload: SyncTptReceptionPayload) => {
      return postAuthorizedJSON(
        `${import.meta.env.VITE_BACKEND_URL}/${client}/etl-check-iceberg/run`,
        payload,
      );
    },
    onSuccess: () => {
      toast.success(
        t("sync_tpt_reception.started", {
          defaultValue: "TPT reception synchronization started successfully.",
        }),
      );
    },
    onError: (error: unknown) => {
      const detail = isAxiosError<{ detail?: string }>(error)
        ? error.response?.data?.detail
        : undefined;
      const errorMessage =
        detail ||
        t("sync_tpt_reception.error", {
          defaultValue:
            "An error occurred while starting the TPT reception synchronization.",
        });

      toast.error(errorMessage);
      console.error(
        "Error starting the TPT reception synchronization:",
        error,
      );
    },
  });
};
